<template>
  <div v-if="restaurantId === -1" id="products-tabs" class="tab-content">

    <add-modifier-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />


    <div @click="addNewData" class="tr-button blue-button"><i class="fas fa-plus"></i> Add New Modifier</div>
    <div id="menu-category" class="menu-list modifiers">
      <div class="menu-list-item heading">
        <div class="menu-list-item-column">Modifier Name</div>
        <div class="menu-list-item-column">Instructions</div>
        <div class="menu-list-item-column">Actions</div>
      </div>

      <div v-for="modifier in modifierlist" :key="modifier.id" class="menu-list-item">
        <!--const {name, id, price, description, restaurant_id, size, section, size_id, section_id, hasModifiers, photoUrl, complete_your_meal} = this.data        -->
        <div class="menu-list-item-column">{{ modifier.name }}</div>
        <div class="menu-list-item-column">{{ modifier.instructions }}</div>
        <div class="menu-list-item-column">
          <div @click="editData(modifier)" class="list-button"><i class="fas fa-edit"></i>Edit</div>
          <div @click.stop="confirmDelete(modifier.id)" class="list-button"><i class="fas fa-trash"></i>Delete</div>

        </div>
      </div>
    </div>
  </div>
  <div v-else>
    Please select a restaurant
  </div>
</template>

<script>
import AddModifierSidebar from './AddModifierSidebar'

export default {
  props: {
    restaurantId: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  watch: {
    restaurantId (newVal) { // watch it
      this.restaurantId = newVal
      this.getModifierList()
    }
  },
  components: {
    AddModifierSidebar
  },
  data () {
    return {
      addNewDataSidebar: false,
      sidebarData: {},
      resId: '',
      itemsPerPage: 20,
      selected: []
    }
  },
  mounted () {
    this.getModifierList()
  },
  beforeMount () {
    this.resId = this.restaurantId
  },
  methods: {
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val

      if (val === false) {
        this.getModifierList()
        this.sidebarData = {}
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.sidebarData.restaurantId = this.restaurantId
      this.toggleDataSidebar(true)
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },

    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text: `Status changed to: ${text}`
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        clickNotClose: true,
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    confirmDelete (id) {
      this.openConfirm(() => {
        this.deleteData(id)
      }, () => {

      })
    },
    deleteData (id) {
      const obj = {
        restaurantId: this.restaurantId,
        modifierId: id
      }
      this.$store.dispatch('api/removeModifier', obj).then(() => {
        this.$vs.notify({
          title: 'Delete',
          text: 'Item deleted succesfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }).catch(err => { console.error(err) })
    },
    getModifierList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getModifierList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },
  computed: {
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.modifierlist.length
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    modifierlist () {
      return this.$store.state.api.modifierlist
    }
  }
}
</script>
